/**
 * Converts a hex color code with alpha value to RGBA string
 * @param hex - Hex color code (e.g., '#ff0000')
 * @param alpha - Alpha value (0-1)
 * @returns RGBA string (e.g., 'rgba(255, 0, 0, 0.5)')
 */
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
